const ITEMS = [
  "Serving DC",
  "Maryland",
  "Virginia",
  "Nationwide",
  "Expedited Passports",
  "Urgent Visas",
  "Apostille Services",
  "Expedited Processing",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative bg-[#0b192c] py-5 overflow-hidden border-y border-white/5" data-testid="marquee">
      <div className="noise-overlay" />
      <div className="flex whitespace-nowrap animate-marquee will-change-transform">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-bold text-2xl md:text-3xl text-white/90 px-8">{item}</span>
            <span className="w-2 h-2 rounded-full bg-[#d90429]" />
          </span>
        ))}
      </div>
    </div>
  );
};
